import React from 'react';
import type { RetailerPromo } from '../../@types/Retailer';

interface PromoProps {
  promo: RetailerPromo;
  onClick: () => void;
}

const Promo = ({ promo, onClick }: PromoProps) => (
  <div className="overflow-grid-item">
    <div className="overflow-grid-content">
      <div data-wx-offercard="" onClick={onClick}>
        {promo.image && (
          <div className="offer-card-image-container">
            <img src={`${promo.image}?w=600&q=72`} alt="" className="offer-card-image" />
          </div>
        )}
        <div className="offer-card-content">
          <div className="offer-card-heading">{promo.title}</div>
        </div>
      </div>
    </div>
  </div>
);

export default Promo;
